import { Tooltip, Icon, Modal, Link, Text } from '@nike/eds'
import { useState } from 'react'

function toClipboard(text: string) {
  navigator.clipboard.writeText(text)
}

function TrackAndTraceDetailsHeader({ onCopyBtnClick }) {
  return (
    <header>
      <Text font="title-3" as="h3" style={{ display: 'inline-block' }}>
        Track and Trace event JSON
      </Text>
      <Tooltip
        bodySlot={
          <Text as="span" font="body-2">
            Copy
          </Text>
        }
        placement="right"
        isDark={true}
      >
        <Link as="button" onClick={onCopyBtnClick} className="eds-spacing--ml-12">
          <Icon name="CopyPaste" size="m" />
        </Link>
      </Tooltip>
    </header>
  )
}

export function TrackAndTraceDetails({ event }) {
  const [visible, setVisible] = useState(false)

  function copyEventToClipboard() {
    toClipboard(
      JSON.stringify(event, (key, value) => (key === '__typename' ? undefined : value), 2)
    )
  }

  return (
    <>
      <Tooltip bodySlot={<span>View JSON</span>} placement={'top'} isDark={true}>
        <Link as="button" onClick={() => setVisible(!visible)}>
          <Icon name="Report" size="m" />
        </Link>
      </Tooltip>
      <Modal
        isOpen={visible}
        onDismiss={() => setVisible(false)}
        headerSlot={<TrackAndTraceDetailsHeader onCopyBtnClick={copyEventToClipboard} />}
      >
        <pre>
          {JSON.stringify(event, (key, value) => (key === '__typename' ? undefined : value), 2)}
        </pre>
      </Modal>
    </>
  )
}
